import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import CustomLayout from "../components/Layout";
import PrivateRoute from "./privateRoute";
import LayoutAdmin from "../components/Admin/Layout";

const RenderRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/login"
          element={<LazyComponentLoader component="Admin/Login" />}
        />
        <Route
          path="/forgot-password"
          element={<LazyComponentLoader component="Admin/ForgotPassword" />}
        />
        <Route
          path="/admin/*"
          element={<PrivateRoute element={<LayoutAdmin />} />}
        >
          <Route
            index
            element={<Navigate to="/admin/request-einvoice-issuance" />}
          />
          <Route
            path="request-einvoice-issuance"
            element={<LazyComponentLoader component="Admin/Home" />}
          />
          <Route
            path="profile"
            element={<LazyComponentLoader component="Admin/Profile" />}
          />
          <Route
            path="accounts"
            element={<LazyComponentLoader component="Admin/Accounts" />}
          />
          <Route
            path="accounts/create"
            element={<LazyComponentLoader component="Admin/Accounts/Create" />}
          />
          <Route
            path="accounts/update/:userId"
            element={<LazyComponentLoader component="Admin/Accounts/Update" />}
          />
          <Route
            path="logs"
            element={<LazyComponentLoader component="Admin/Logs" />}
          />
        </Route>

        <Route path="/" element={<CustomLayout />}>
          <Route index element={<LazyComponentLoader component="Home" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const LazyComponentLoader = ({ component }) => {
  const LazyComponent = lazy(() => import(`../pages/${component}`));
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyComponent />
    </Suspense>
  );
};

export default RenderRoutes;
